import { useDataContext } from "../../modules/Data/DataProvider";
import useUpdateUserData from "../../modules/Data/useUpdateUserData";
import useFilterCards from "./hooks/useFilterCards";
import type { IVehicleFilter } from "./components/VehicleFilter";
import type { IVehicleCard } from "./components/VehicleCard";

export type IUiMVehicleSelector = {
  vehicleFilters: IVehicleFilter[];
  filteredCards: IVehicleCard[];
  selectedFilter?: string;
  handleFilterChange: (id: string) => void;
  handleSelectVehicle: (id: string) => void;
};

const useUiMVehicleSelector = (onClose?: any): IUiMVehicleSelector => {
  const { vehicleCards, vehicleFilters, updateIsLoading, vehicleData } = useDataContext();
  const { updateVehicleData } = useUpdateUserData();
  const { filteredCards, handleFilterChange, selectedFilter } = useFilterCards(
    vehicleCards ?? [],
    vehicleFilters ?? [],
  );

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSelectVehicle = (id: string) => {
    if (vehicleData?.vehicleId !== id) {
      updateIsLoading(true);
      updateVehicleData(id);
    }
    handleClose();
  };

  return {
    vehicleFilters: vehicleFilters ?? [],
    filteredCards,
    selectedFilter,
    handleFilterChange,
    handleSelectVehicle,
  };
};

export default useUiMVehicleSelector;
